import { render, staticRenderFns } from "./NavLinks.vue?vue&type=template&id=685b8285&scoped=true&"
import script from "./NavLinks.vue?vue&type=script&lang=ts&"
export * from "./NavLinks.vue?vue&type=script&lang=ts&"
import style0 from "./NavLinks.vue?vue&type=style&index=0&id=685b8285&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685b8285",
  null
  
)

export default component.exports